export interface WeeklyReportIndex {
  id: number;
  period: Date;
  ad: number;

  idx: number;
  from: string;
  to: string;

  meta: any;

  is_public: boolean;

  reports: {[type: string]: WeeklyReport};

  updated_at: Date;
}

// 数値系は decimal なので string
export interface WeeklyReport {
  id: number;
  weekly_report_index_id: number;

  type: string;
  beginning_balance: string|null;

  trade_profit: string|null;
  trade_per: string|null;

  swap_profit: string|null;
  swap_per: string|null;

  sum_profit: string|null;
  sum_per: string|null;

  comment: string|null;
}

export interface WeeklyReportResponse {
  [idx: string]: WeeklyReportIndex
}

// TODO: 二重管理状態なので PoolTypeProperty::MAP から取得する形式に変更したい
export const PoolTypeMap = [
  {pool: 'BB',      acc: 'BB0',   pension: false,  res_b: 2,   hdc: '0.20',   mng: '0'},
  {pool: 'EF',      acc: 'EF0',   pension: false,  res_b: 4,   hdc: '0.25',   mng: '0'},
  {pool: 'HF',      acc: 'HF0',   pension: false,  res_b: 6,   hdc: '0.25',   mng: '0'},
  {pool: 'UF',      acc: 'UF0',   pension: false,  res_b: 18,  hdc: '0.30',   mng: '0'},
  {pool: 'AX',      acc: 'AX0',   pension: false,  res_b: 6,   hdc: '0.25',   mng: '0'},
  {pool: 'AX2',     acc: 'A20',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'GBPX',    acc: 'GX0',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'DH',      acc: 'DH0',   pension: false,  res_b: 2,   hdc: '0.10',   mng: '0'},
  {pool: 'WH',      acc: 'WH0',   pension: false,  res_b: 4,   hdc: '0.15',   mng: '0'},
  {pool: 'TH',      acc: 'TH0',   pension: false,  res_b: 6,   hdc: '0.25',   mng: '0'},
  {pool: 'TH2',     acc: 'T20',   pension: false,  res_b: 6,  hdc: '0.25',   mng: '0'},
  {pool: 'TH2年金', acc: 'T25',   pension: true,   res_b: 12,  hdc: '0.00',   mng: '0'},
  {pool: 'THMX',    acc: 'TX0',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'THMX年金',acc: 'TX5',   pension: true,   res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'THMX2',   acc: 'TM0',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'OL',      acc: 'OL0',   pension: false,  res_b: 12,   hdc: '0.25',   mng: '0'},
  {pool: 'OL2',     acc: 'O20',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'OL3',     acc: 'O30',   pension: false,  res_b: 18,  hdc: '0.30',   mng: '0'},
  {pool: 'OL4',     acc: 'O40',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'PE',      acc: 'PE0',   pension: false,  res_b: 12,  hdc: '0.20',   mng: '0'},
  {pool: 'SP',      acc: 'SP0',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0.0025'},
  {pool: 'ST',      acc: 'ST0',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0.0025'},
  {pool: 'WYPS',    acc: 'WY0',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'WYPM'  ,  acc: 'WY3',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'WYPM年金',acc: 'WY4',   pension: true,   res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'WYPX',    acc: 'WY5',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
  {pool: 'CHFX',    acc: 'CH0',   pension: false,  res_b: 12,  hdc: '0.25',   mng: '0'},
];

export const PoolTypes = PoolTypeMap.map(x => x.pool);

export const CurrencyTypes = [
  'JPY',
  'CHF',
  'USD',
  'AUD',
  'GBP',
  'EUR'
];
